import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchPageList } from "../actions/page";
import { useSelector } from "react-redux";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import {
  createDateColumn,
  createFullDateColumn,
} from "../utils/agGridDateColumn";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { t } from "i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import { toast } from "react-toastify";

const PagesList = () => {
  const dispatch = useDispatch();
  const { pageList } = useSelector((state) => state.pageReducer);

  //breadcrumb
  const translateModule = "page";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchPageList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.title) return null;
    return (
      <ButtonColumn editLink={`/pages-edit/` + params.data.id} value={params} />
    );
  };

  const columnDefs = [
    {
      headerName: "Naslov",
      field: "title",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: "Jezik",
      field: "language",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    createFullDateColumn("Datum izmene", "updatedAt"),
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchPageList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={pageList}
        columnDefs={columnDefs}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="pages-list"
      />
    </Fragment>
  );
};

export default PagesList;
